import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IHolidays, IIntervention } from 'src/app/models/IHolidays';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LocationsService } from 'src/app/Services/AdminConfigurations/locations.service';
import { Defaults } from 'src/app/Utilities/defaults';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { ISnomed } from 'src/app/models/IProcedureCodes';
import { ICptOrdersComponent, IOrdersLoinc } from 'src/app/models/ICptOrdersComponent';
import { CptordersService } from 'src/app/Services/NewVisitNote/cptorders.service';

@Component({
  selector: 'app-intervention-outcome',
  templateUrl: './intervention-outcome.component.html',
  styleUrls: ['./intervention-outcome.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class InterventionOutcomeComponent implements OnInit {
  headercolumnsToDisplay = [];
  // columnsToDisplay = ['planned', 'status', 'stringdate', 'negotionType', 'HCPCSCode', 'HCPCSName', 'reason', 'Action'];
  columnsToDisplay = [];
  Interventiondata: IIntervention[] = [];
  dataSource = new MatTableDataSource(this.Interventiondata);
  //expandedElement: PeriodicElement | null;
  public ispopup: boolean = false;
  public result: any;
  istblTh_hidden: boolean = true
  show: boolean;
  out: boolean;
  showfield: boolean;
  uidItems: boolean;
  outfield: boolean;
  showAssesment: boolean = false;
  public type: string;
  public procedureId: string;
  message: string = '';
  fnDelete(element: IIntervention) {
    if (element.type == 'Intervention') {

      this.message = "Are you sure to delete Intervention details? ";
    } else if ((element.type == 'Assessment')) {

      this.message = "Are you sure to delete Assessment details? ";
    } else {
      this.message = "Are you sure to delete Outcomes details? ";
    }

    const message = this.message
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '120px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {

        this.InterventioObj.interventionId = element.interventionId;

        this.InterventioObj.dbOperation = 'Delete';
        this.LocationsService.insertInterventionDetails(this.InterventioObj).subscribe(
          results => {
            this.toastr.success(results);
            this.FetchInterventionDetails(element.type);
            this.onClearClick();
            this.translationshow = false

          }, (err: any) => {
            console.log(err);
          });
        //this.FetchInterventionDetails(this.type)
      }
    })
  }
  btnType: string = '';
  isEdit: boolean = false;
  showInfo() {
    this.intervenceId = 0;
    this.btnType = 'Insert';
    if (this.type == 'Assessment') {
      this.showAssesment = !this.showAssesment;
      this.headercolumnsToDisplay = ['Planned Assessment', 'Status', 'Date', 'Action'];
      this.columnsToDisplay = ['planned', 'status', 'stringdate', 'Action'];
      this.dataSource.data = this.Interventiondata.filter(x => x.type == 'Assessment');
    } else if (this.type == 'Intervention') {
      this.show = !this.show;
      this.negotionDx = false;
      this.negotionRx = false;
      this.negotionVitals = false;
      this.headercolumnsToDisplay = ['Planned Intervention', 'Status', 'Date', 'NegotionType', 'HCPCSCode', 'HCPCSName', 'Reason', 'Action'];
      this.columnsToDisplay = ['planned', 'status', 'stringdate', 'negotionType', 'HCPCSCode', 'HCPCSName', 'reason', 'Action'];
      this.dataSource.data = this.Interventiondata.filter(x => x.type == 'Intervention');
    } else if (this.type == 'UDI') {
      this.uidItems = !this.uidItems;
      this.isUDI = 1;
      this.validUDI = "";
      this.headercolumnsToDisplay = ['Device Code', 'UDI', 'Assigning Authority', 'Scoping Entity', 'Action'];
      this.columnsToDisplay = ['planned', 'status', 'assigningAuthority', 'scopingEntity'];
      this.dataSource.data = this.dataSource.data.filter(x => x.type == 'UDI' && x.procedureId == this.procedureId);
    }
    else {
      this.show = false
      this.out = !this.out;
      this.headercolumnsToDisplay = ['Item', 'Outcome', 'Date', 'Action'];
      this.columnsToDisplay = ['planned', 'status', 'stringdate', 'Action'];
      this.dataSource.data = this.Interventiondata.filter(x => x.type == 'Outcome');

    }
    this.validoutcomes = '';
  }

  setcolumWidth(columnumber: string) {
    switch (columnumber) {
      case 'planned':
        return { 'width': '50%' };
      case 'status':
        return { 'width': '10% ' };
      case 'stringdate':
        return { 'width': '5% ' };
      case 'Action':
        return { 'width': '5%' };

    }
  }
  intervenceId: any = 0;
  T_Icdvalue: string = "";
  T_Cptvalue: string = "";
  T_Hcpcsvalue: string = "";
  UpdateIntervention(element: IIntervention) {
    if (this.type == "Outcomes") {
      this.show = false;
      this.out = true;
      this.btnType = 'Update';
      this.intervenceId = element.interventionId;
      this.Interventionform.patchValue({
        Intervention: element.planned,
        Item: element.planned,
        outcome: element.status,
        date2: element.stringdate,

      });
      if (element.stringdate == null || element.stringdate == undefined) {
        this.Interventionform.patchValue({
          date2: '', //element.startDate,
        })
      } else {
        this.Interventionform.patchValue({
          date2: new Date(element.stringdate), //element.startDate,
        })
      }

    } else if (this.type == "Intervention") {
      this.show = true;
      this.out = false;
      this.btnType = 'Update';
      this.intervenceId = element.interventionId;
      this.Interventionform.patchValue({
        Intervention: element.planned,
        date: element.stringdate,
        status: element.status,
        negation: element.negation,
        reason: element.reason,
        negotionType: element.negotionType,
        T_Icd: element.T_Icd,
        T_Cpt: element.T_Cpt,
        T_Hcpcs: element.T_Hcpcs,
        HCPCSCode: element.HCPCSCode,
        HCPCSName: element.HCPCSName,

      });
      this.T_Icdvalue = element.T_Icd;
      this.T_Cptvalue = element.T_Cpt;
      this.T_Hcpcsvalue = element.T_Hcpcs;
      this.negtype = element.negotionType

      if (element.stringdate == null || element.stringdate == undefined) {
        this.Interventionform.patchValue({
          date: '', //element.startDate,
        })
      } else {
        this.Interventionform.patchValue({
          date: new Date(element.stringdate), //element.startDate,
        })
      }
      // this.Interventioncheck(element.negotionType.toString(), true);
      if (this.negtype == 'Vitals') {
        this.negotionDx = false;
        this.negotionRx = false;
        this.negotionVitals = true;
      } else if (this.negtype == 'Rx') {
        this.negotionDx = false;
        this.negotionRx = true;
        this.negotionVitals = false;
      } else if (this.negtype == 'Dx') {
        this.negotionDx = true;
        this.negotionRx = false;
        this.negotionVitals = false;
      } else {
        this.negtype = '';
      }

    }
  }

  Interventionform: FormGroup;
  submitted = false;
  public lstLocations: ILocationDetails[];
  public cptcode: string = '';
  public cptType: string = '';
  public side: string = '';
  public Procedure: string = '';
  public levels: string = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private formBuilder: FormBuilder, private procedureCodesService: ProcedureCodesService, public dialog: MatDialog, private schedulerservice: SchedularServiceService, public datepipe: DatePipe, private LocationsService: LocationsService, private toastr: ToastrService, private cptservice: CptordersService,
    public dialogRef: MatDialogRef<InterventionOutcomeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IIntervention, @Inject(MAT_DIALOG_DATA) public details: DialogData,) {
    if (details.headerText == 'Assessment') {
      this.type = 'Assessment';
      this.isEdit = false;
    } else if (details.headerText == 'Intervention') {
      this.type = 'Intervention';
      this.isEdit = true;
    } else if (details.headerText == 'UDI') {
      this.procedureId = details.proc.procedureId;
      this.cptcode = details.proc.procCPT + " - ";
      if (details.proc.procType != null && details.proc.procType != undefined && details.proc.procType != '')
        this.cptType = " " + details.proc.procType;
      if (details.proc.procSide != null && details.proc.procSide != undefined && details.proc.procSide != '')
        this.side = " " + details.proc.procSide;
      if (details.proc.procedureName != null && details.proc.procedureName != undefined && details.proc.procedureName != '')
        this.Procedure = " " + details.proc.procedureName;
      if (details.proc.procLevels != null && details.proc.procLevels != undefined && details.proc.procLevels != '')
        this.levels = " " + details.proc.procLevels;
      details.headerText = 'Add Implantable Device Information'
      this.type = 'UDI';
      this.isEdit = false;
    } else {
      this.type = 'Outcomes';
      this.isEdit = true;
    }

  }
  IsSelectedType = 'SNOMED'
  InterventionSnomedChange(type: string) {
    this.IsSelectedType = type;
    this.Interventionform.controls['Intervention'].setValue("");
    this.snomedtext = '';
    this.snomedtext1 = '';
  }
  IsNegetionType = '';
  NegationReasonChange(type: string) {
    this.IsNegetionType = type

  }
  OrdersLoinc: IOrdersLoinc[] = [];

  searchResultValue: string = "";
  async onOrderResultDropdownSearch(val: any) {
    this.OrdersLoinc = [];
    this.searchResultValue = val;
    if (this.searchResultValue.length >= 3) {
      await this.cptservice.getOrdersLoincMasterBySearch(this.searchResultValue).subscribe(
        data => {
          this.OrdersLoinc = data;
        }
      );
    } else {
      this.OrdersLoinc = [];

    }
  }
  onProviderselectionchange() {

  }
  MastercptOrdersDisplay: ICptOrdersComponent[];
  fnManualOrderChange(element) {
    element.loincDescription = element.loincCommanName + "~" + element.loincNumber
    this.snomedtext = element.loincDescription;
  }
  onClickDropdown() {

  }
  public negtype: string = '';
  negotionDx: boolean = false;
  negotionRx: boolean = false;
  negotionVitals: boolean = false;

  Interventioncheck(type: string, event) {
    // alert(event.checked)
    if (event.checked == true) {
      if (type == 'Dx') {
        this.negotionDx = true;
        this.negotionRx = false;
        this.negotionVitals = false;

      } else if (type == 'Rx') {
        this.negotionDx = false
        this.negotionVitals = false
        this.negotionRx = true;
      } else if (type == 'Vitals') {
        this.negotionDx = false;
        this.negotionRx = false;
        this.negotionVitals = true;
      }
      this.negtype = type;
    } else {
      this.negotionDx = false;
      this.negotionRx = false;
      this.negotionVitals = false;
      this.negtype = '';
    }

  }


  ngOnInit() {

    this.dataSource.paginator = this.paginator;
    this.Interventionform = this.formBuilder.group({

      date: [''],
      status: [''],
      Intervention: [''],
      outcome: [''],
      Item: [''],
      date2: [''],
      UDIText: [''],
      UDIIntervention: [''],
      Scoping: [''],
      Assigning: [''],
      negation: [''],
      reason: [''],
      negotionType: [''],
      HCPCSCode: [''],
      HCPCSName: [''],
      T_Icd: [''],
      T_Cpt: [''],
      T_Hcpcs: [''],
      IsType: ['']

    });

    this.FetchInterventionDetails(this.type)

    if (this.type == 'Assessment') {
      this.headercolumnsToDisplay = ['Planned Assessment', 'Status', 'Date', 'Action'];
      this.columnsToDisplay = ['planned', 'status', 'stringdate', 'Action'];
    } else if (this.type == 'Intervention') {
      this.headercolumnsToDisplay = ['Planned Intervention', 'Status', 'Date', 'NegotionType', 'HCPCSCode', 'HCPCSName', 'Reason', 'Action'];
    } else if (this.type == 'UDI') {
      this.columnsToDisplay = ['planned', 'status', 'assigningAuthority', 'scopingEntity'];
      this.headercolumnsToDisplay = ['Device Code', 'UDI', 'Assigning Authority', 'Scoping Entity'];
    }
    else {
      this.headercolumnsToDisplay = ['Item', 'Outcome', 'Date', 'Action'];
    }
    //this.showInfo();
    this.show = false;
  }
  getLocations() {
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true)
    });
  }
  isUDI: number = 1;
  validoutcomes: string;
  validUDI: string;
  PassParameter: string;
  InterventioObj: IIntervention = new IIntervention();
  SaveIntervention(event: any) {

    if (this.Interventionform.value.Intervention == '' && this.Interventionform.value.status == '' &&
      this.Interventionform.value.date == '' && this.Interventionform.value.negation == '' && this.Interventionform.value.negotionType == '' && this.Interventionform.value.HCPCSCode == '' && this.Interventionform.value.HCPCSName == '' && this.Interventionform.value.T_Icd == '' && this.Interventionform.value.T_Cpt == '' && this.Interventionform.value.T_Hcpcs == '' && this.Interventionform.value.outcome == '' && this.Interventionform.value.Item == '' && this.Interventionform.value.date2 == '') {
      this.toastr.error("Please Enter the any Value");
      return false
    }

    this.PassParameter = event;
    if (event == 'Intervention' || event == 'Assessment') {
      this.InterventioObj.status = this.Interventionform.get('status').value;
      // this.InterventioObj.planned = this.Interventionform.get('Intervention').value;
      if (this.snomedtext != undefined && this.snomedtext != '') {
        this.InterventioObj.planned = this.snomedtext;
      } else {
        this.InterventioObj.planned = this.Interventionform.get('Intervention').value;
      }

      if (this.snomedtext1 != undefined && this.snomedtext1 != '') {
        this.InterventioObj.negation = this.snomedtext1;
      } else {
        this.InterventioObj.negation = this.Interventionform.get('negation').value;
      }
      this.InterventioObj.HCPCSCode = this.Interventionform.get('HCPCSCode').value;
      this.InterventioObj.HCPCSName = this.Interventionform.get('HCPCSName').value;
      this.InterventioObj.T_Icd = this.Interventionform.get('T_Icd').value;
      this.InterventioObj.T_Cpt = this.Interventionform.get('T_Cpt').value;
      this.InterventioObj.T_Hcpcs = this.Interventionform.get('T_Hcpcs').value;
      this.InterventioObj.IsType = this.IsNegetionType;
      this.InterventioObj.negotionType = this.negtype;
      this.InterventioObj.reason = this.Interventionform.get('reason').value;
      this.InterventioObj.procedureId = '';
      this.InterventioObj.type = event;
      if (this.Interventionform.value.date != 'Invalid Date' && this.Interventionform.value.date != "" && this.Interventionform.value.date != undefined && this.Interventionform.value.date != null) {
        var Hdate = this.datepipe.transform(this.Interventionform.value.date, 'yyyy-MM-dd');
        this.InterventioObj.date = Hdate != null ? new Date(Hdate) : null;
      }

    } else if (event == 'UDI') {
      if (this.Interventionform.value.UDIText != '') {

        this.InterventioObj.status = this.Interventionform.get('UDIText').value;
        this.InterventioObj.procedureId = this.procedureId;
        this.InterventioObj.scopingEntity = this.Interventionform.get('Scoping').value;
        this.InterventioObj.assigningAuthority = this.Interventionform.get('Assigning').value;
        if (this.snomedtext != undefined && this.snomedtext != '') {
          this.InterventioObj.planned = this.snomedtext;
        } else {
          this.InterventioObj.planned = this.Interventionform.get('UDIIntervention').value;
        }

        this.InterventioObj.type = event;
        var Hdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
        this.InterventioObj.date = Hdate != null ? new Date(Hdate) : null;
        this.isUDI = 0;
        this.validUDI = "";
      } else {
        this.isUDI = 1;
        this.validUDI = "UDI is Mandatory";
        return false;
      }
    }
    else {
      if (this.Interventionform.value.outcome != '' || this.Interventionform.value.Item != '' || this.Interventionform.value.date2 != '') {
        this.InterventioObj.procedureId = '';
        this.InterventioObj.status = this.Interventionform.value.outcome;
        this.InterventioObj.planned = this.Interventionform.value.Item;
        this.InterventioObj.type = event;
        if (this.Interventionform.value.date2 != 'Invalid Date' && this.Interventionform.value.date2 != "" && this.Interventionform.value.date2 != undefined && this.Interventionform.value.date2 != null) {
          var Hdate = this.datepipe.transform(this.Interventionform.value.date2, 'yyyy-MM-dd');
          this.InterventioObj.date = Hdate != null ? new Date(Hdate) : null;
        }

      } else {
        this.validoutcomes = "Please select Item";
        return false;
      }
    }
    var test = this.onSnomedSearchCodes;
    this.InterventioObj.dbOperation = this.btnType;//DBType;
    this.InterventioObj.date = Hdate != null ? new Date(Hdate) : null;
    this.InterventioObj.encounterId = sessionStorage.getItem("encounterid");
    this.InterventioObj.interventionId = this.intervenceId;
    this.LocationsService.insertInterventionDetails(this.InterventioObj).subscribe(
      results => {
        this.toastr.success(results);
        this.FetchInterventionDetails(this.PassParameter);
        this.onClearClick();
        this.translationshow = false
      }, (err: any) => {
        console.log(err);
      });
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  FetchInterventionDetails(name: any) {
    this.LocationsService.getInterventiondetails(sessionStorage.getItem("encounterid")).subscribe(
      (results: IIntervention[]) => {
        this.Interventiondata = results;
        results.forEach(ele => {
          if (ele.planned == null) {
            ele.planned = '';
          } else {
            if (ele.planned.includes('~')) {
              ele.planned = ele.planned.replace("~", '(');
              ele.planned = ele.planned + ")";
            }
          }
          if (ele.status == null) {
            ele.status = '';
          }
          if (ele.createdOn != null) {
            var Interventiondate = this.datepipe.transform(ele.createdOn, 'MM/dd/yyyy').toString();;
            ele.stringdate = Interventiondate;
            if (Interventiondate == '01/01/0001') {
              ele.stringdate = '';
            }
          }
        })
        this.dataSource.data = this.Interventiondata;


        if (name == 'Assessment') {
          this.dataSource.data = this.dataSource.data.filter(x => x.type == 'Assessment');
        } else if (name == 'Intervention') {

          this.headercolumnsToDisplay = ['Planned Intervention', 'Status', 'Date', 'NegotionType', 'HCPCSCode', 'HCPCSName', 'Reason', 'Action'];
          this.columnsToDisplay = ['planned', 'status', 'stringdate', 'negotionType', 'HCPCSCode', 'HCPCSName', 'reason', 'Action'];
          this.dataSource.data = this.Interventiondata.filter(x => x.type == 'Intervention');

        } else if (name == 'UDI') {
          this.headercolumnsToDisplay = ['planned', 'status', 'assigningAuthority', 'scopingEntity'];
          this.columnsToDisplay = ['planned', 'status', 'assigningAuthority', 'scopingEntity'];

          this.dataSource.data = this.dataSource.data.filter(x => x.type == 'UDI' && x.procedureId == this.procedureId);
        }
        else {
          this.headercolumnsToDisplay = ['Item', 'Outcome', 'Date', 'Action'];
          this.columnsToDisplay = ['planned', 'status', 'stringdate', 'Action'];
          this.dataSource.data = this.dataSource.data.filter(x => x.type == 'Outcome');
        }
      }, (err: any) => console.log(err));
  }

  onClearClick() {
    this.Interventionform.controls['date'].setValue('');
    this.Interventionform.controls['date2'].setValue('');
    this.Interventionform.controls['status'].setValue('');
    this.Interventionform.controls['Intervention'].setValue('');
    this.Interventionform.controls['outcome'].setValue('');
    this.Interventionform.controls['Item'].setValue('');
    this.Interventionform.controls['UDIText'].setValue('');
    this.Interventionform.controls['UDIIntervention'].setValue('');
    this.Interventionform.controls['Scoping'].setValue('');
    this.Interventionform.controls['Assigning'].setValue('');
    this.Interventionform.controls['negation'].setValue('');
    this.Interventionform.controls['reason'].setValue('');
    this.Interventionform.controls['negotionType'].setValue('');
    this.Interventionform.controls['HCPCSCode'].setValue('');
    this.Interventionform.controls['HCPCSName'].setValue('');
    this.Interventionform.controls['T_Icd'].setValue('');
    this.Interventionform.controls['T_Cpt'].setValue('');
    this.Interventionform.controls['T_Hcpcs'].setValue('');

    this.negotionDx = this.negotionRx = this.negotionVitals = false
    this.snomedtext = '';
    this.snomedtext1 = '';
    this.show = false;
    this.out = false;
    this.uidItems = false;
    this.showAssesment = false;
    this.onSnomedSearchCodes = [];
    this.validoutcomes = '';
    this.isUDI = 0;
    this.validUDI = "";
    this.negtype = '';
    this.IsNegetionType = '';
    this.translationshow = false
    this.intervenceId = 0;
  }

  onCancelClick() {
    this.show = false;
  }


  searchresults: string = "";
  public MasterSnomedList: ISnomed[];
  searchMasterSnomedcodes(searchText: any) {

    if (searchText != null && searchText != undefined && searchText != '') {
      this.procedureCodesService.getSnomedBySearch(searchText).subscribe(
        results => {
          this.MasterSnomedList = results;
        }, (err: any) => console.log(err));
    }
  }
  onSnomedSearchCodes: ISnomed[] = [];

  searchReferraldropdownValue: string = "";
  async onSnomedSearch(val: any) {
    this.searchReferraldropdownValue = val;
    if (this.searchReferraldropdownValue.length > 2) {

      await this.procedureCodesService.getSnomedBySearch(this.searchReferraldropdownValue).subscribe(

        data => {
          this.onSnomedSearchCodes = data;
          this.onSnomedSearchCodes.forEach(ele => {
            ele.ConceptCodeNameCode = ele.ConceptName + "(" + ele.ConceptCode + ")";
          })
        }, (err: any) => console.log(err));
    }
    else {
      this.onSnomedSearchCodes = [];
      this.snomedtext = '';
      this.snomedtext1 = '';

    }
  }
  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  ontextchange(value: any) {
    if (value != '') {
      this.isUDI = 0;
      this.validUDI = "";
    } else {
      this.isUDI = 1;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }


  public snomedtext: string;
  onSelectionChanged(event) {
    this.snomedtext = event.ConceptName + "~" + event.ConceptCode;
  }
  public snomedtext1: string;

  onSelectionChanged1(event) {
    this.snomedtext1 = event.ConceptName + "~" + event.ConceptCode;
  }
  translationshow: boolean = false;

  TranslationClick() {
    this.translationshow = !this.translationshow
  }

  TranslationClose() {
    this.translationshow = false
  }

}
export interface DialogData {
  headerText: string;
  proc: any;
}